<template>
  <div class="c-text-between px-container c-flex-wrap">
    <div class="display-width c-text-column" style="align-items: flex-start; justify-content: center;">
      <h1>全球经销商伙伴</h1>
      <span class="c-mt-5 c-mb-10 c-text-left ">
        我们很自豪能与一个专注的合作伙伴合作，他们分享我们对机器人和创新的热情。这个页面提供了我们目前授权经销商的概述。
      </span> 
      <div class="c-text-justify-start c-flex-wrap c-mt-10 c-mb-10"> 
        <div class="buttonSite">
          成为我们的合作伙伴
        </div>
      </div>
    </div>
     
    <div class="display-width">
      <img src="@/assets/images/events/Event page-1.jpg" alt=""
        style="    height: auto; max-width: 100%;">
    </div>
  </div>
  <div class="line-with-text px-container">
    <hr class="divider">
    <span class="line-text">我们在欧洲的销售合作伙伴</span>
    <hr class="divider">
  </div>
  <div class="c-text-between px-container c-mb-60">
    <div class="display-width c-text-column" style="align-items: flex-start; justify-content: center;">
      <h1>欧洲</h1>
    </div> 
  </div> 
  <div class="px-container stress-content"> 
    <div v-for="(item, index) in contentList" :key="item.name + index" style="display: flex; flex-direction: column; min-height: 180px;">
      <div style="width: 100%; overflow: hidden;" class="c-text-both">
        <img :src="item.url" class="image-style" style="width: 100%; height: 100%; object-fit: cover;aspect-ratio: 716/450;" />
      </div>
      <div class="c-text-left c-width-precent-100 c-mt-10">
        {{ item.name }}
      </div>
      <h3 class="c-text-left c-width-precent-100 c-mt-10 c-mb-10">
        {{ item.title }}
      </h3>
      <div class="c-text-left c-width-precent-100">
        {{ item.value }}
      </div> 
      <div class="c-text-between" style="text-align: left;">
        <!-- <a :href="item.sites" class="linkTag">{{item.sites}}</a> -->
        <a   :href=item.sites  class="linkTag" target="_blank" title="Amtest Group" rel="noopener">
          {{item.sites}}
        </a> 
        </div>  
    </div>
  </div>
  <div class="line-with-text px-container">
    <hr class="divider">
    <span class="line-text">我们在亚洲的销售合作伙伴</span>
    <hr class="divider">
  </div>
  <div class="c-text-between px-container c-mb-60">
    <div class="display-width c-text-column" style="align-items: flex-start; justify-content: center;">
      <h1>亚洲</h1>
    </div> 
  </div> 
  <div class="px-container stress-content"> 
    <div v-for="(item, index) in asiaList" :key="item.name + index" style="display: flex; flex-direction: column; min-height: 180px;">
      <div style="width: 100%; overflow: hidden;" class="c-text-both">
        <img :src="item.url" class="image-style" style="width: 100%; height: 100%; object-fit: cover;aspect-ratio: 716/450;" />
      </div>
      <div class="c-text-left c-width-precent-100 c-mt-10">
        {{ item.name }}
      </div>
      <h3 class="c-text-left c-width-precent-100 c-mt-10 c-mb-10">
        {{ item.title }}
      </h3>
      <div class="c-text-left c-width-precent-100">
        {{ item.value }}
      </div> 
      <div class="c-text-between" style="text-align: left;"> 
        <a   :href=item.sites  class="linkTag" target="_blank" title="Amtest Group" rel="noopener">
          {{item.sites}}
        </a> 
        </div>  
    </div>
  </div>
  <div class="line-with-text px-container">
    <hr class="divider">
    <span class="line-text">我们在加拿大的销售合作伙伴</span>
    <hr class="divider">
  </div>
  <div class="c-text-between px-container c-mb-60">
    <div class="display-width c-text-column" style="align-items: flex-start; justify-content: center;">
      <h1>加拿大</h1>
    </div> 
  </div> 
  <div class="px-container stress-content"> 
    <div v-for="(item, index) in otherList" :key="item.name + index" style="display: flex; flex-direction: column; min-height: 180px;">
      <div style="width: 100%; overflow: hidden;" class="c-text-both">
        <img :src="item.url" class="image-style" style="width: 100%; height: 100%; object-fit: cover;aspect-ratio: 716/450;" />
      </div>
      <div class="c-text-left c-width-precent-100 c-mt-10">
        {{ item.name }}
      </div>
      <h3 class="c-text-left c-width-precent-100 c-mt-10 c-mb-10">
        {{ item.title }}
      </h3>
      <div class="c-text-left c-width-precent-100">
        {{ item.value }}
      </div> 
      <div class="c-text-between" style="text-align: left;"> 
        <a  :href=item.sites class="linkTag" target="_blank" title="Amtest Group" rel="noopener">
          {{item.sites}}
        </a> 
        </div>  
    </div>
  </div>
  <div class="line-with-text px-container">
    <hr class="divider">
    <span class="line-text">我们在中东的销售合作伙伴</span>
    <hr class="divider">
  </div>
  <div class="c-text-between px-container c-mb-60">
    <div class="display-width c-text-column" style="align-items: flex-start; justify-content: center;">
      <h1>中东</h1>
    </div> 
  </div> 
  <div class="px-container stress-content"> 
    <div v-for="(item, index) in eastList" :key="item.name + index" style="display: flex; flex-direction: column; min-height: 180px;">
      <div style="width: 100%; overflow: hidden;" class="c-text-both">
        <img :src="item.url" class="image-style" style="width: 100%; height: 100%; object-fit: cover;aspect-ratio: 716/450;" />
      </div>
      <div class="c-text-left c-width-precent-100 c-mt-10">
        {{ item.name }}
      </div>
      <h3 class="c-text-left c-width-precent-100 c-mt-10 c-mb-10">
        {{ item.title }}
      </h3>
      <div class="c-text-left c-width-precent-100">
        {{ item.value }}
      </div> 
      <div class="c-text-between" style="text-align: left;"> 
        <a  :href=item.sites class="linkTag" target="_blank" title="Amtest Group" rel="noopener">
          {{item.sites}}
        </a> 
        </div>  
    </div>
  </div>
  
</template>

<script>
// import HelloWorld from './components/HelloWorld.vue'

export default {
    metaInfo() {
        return {
          title: this.$route.meta.title, // 从路由获取标题
          meta: [
            { 
              name: 'keywords', 
              content: this.$route.meta.metaTags[0]['content']
            }
          ]
        }
      },
  name: 'App',
  components: {
    // HelloWorld
  },
  data(){
    return {
      eastList:[
        {
          name:'中东',
          title:'LINK GULF',
          value:'Link Gulf LLC 在中东地区运营超过15年，向私立机构、政府部门和大学提供研究与教育设备，覆盖整个中东地区。',
          url:require('@/assets/images/partners/14.png'),
          sites:'https://link-gulf.com'
        }
      ],
      otherList:[
        {
          name:'加拿大',
          title:'CLEARPATH ROBOTICS',
          value:'Clearpath Robotics是全球领先的无人驾驶车辆机器人公司。该公司提供用于自主车辆的硬件和软件解决方案，涵盖矿业、农业、航空和研究等领域',
          url:require('@/assets/images/partners/7.png'),
          sites:'https://clearpathrobotics.com'
        }, 
        // {
        //   name:'美国',
        //   title:'MATHWORKS',
        //   value:'MathWorks成立于1984年，是MATLAB®和Simulink®的开发商，这些是工程师和科学家使用的领先工具。与Franka Robotics的合作使得Franka机器人可以实现直观的实时控制，从而使算法能够高效地在模拟和实际机器人上进行测试。',
        //   url:require('@/assets/images/partners/15.png'),
        //   sites:'https://mathworks.com'
        // }, 
        // {
        //   name:'美国',
        //   title:'NVIDIA',
        //   value:'NVIDIA公司是视觉计算技术的领先者，开发用于PC、工作站、笔记本、掌中宝和游戏主机上的交互式体验产品。总部位于圣克拉拉，全球员工约1,900人。',
        //   url:require('@/assets/images/partners/01-nvidia-logo-horiz-500x200-2c50-d.png'),
        //   sites:'https://nvidia.com'
        // }, 
        // {
        //   name:'美国',
        //   title:'PHYTRON-ROBOTICS',
        //   value:'Phytron-Robotics 是一家专注于高性能驱动技术的公司，提供针对机器人系统的电动驱动、精密运动控制和自动化解决方案。其产品广泛应用于工业机器人、医疗设备以及高科技研发领域。',
        //   url:require('@/assets/images/partners/16.png'),
        //   sites:'https://phytronrobotics.com'
        // }, 
        // {
        //   name:'美国',
        //   title:'MOTIVO ENGINEERING',
        //   value:'Motivo Engineering 提供快速的产品开发和端到端解决方案，服务于农业科技、航空航天、移动性、工业机器人和自动化等行业。从设计到生产，他们创新高效地支持客户。',
        //   url:require('@/assets/images/partners/motivo logo.png'),
        //   sites:'https://www.motivo.com/' 
        // }, 
      ],
      asiaList:[
        {
          name:'泰国',
          title:'GW ADVANCE ENGINEERING CO. LTD.',
          value:'GW Advanced Engineering提供工业自动化的机械、设备和完整的集成服务。公司在泰国拥有10名技术工程师，提供全面的24小时客户支持。',
          url:require('@/assets/images/partners/2.png'),
          sites:'https://gwadvance.co.th'
        }, 
        // {
        //   name:'中国',
        //   title:'CHENLUX TECHNOLOGY LTD.',
        //   value:'Chenlux是一家自动化系统集成公司，拥有12年处理TFT-LCD面板的经验。自2017年以来，公司提供解决方案，如自动引导车（AGV）、移动机器人、仓库管理和软件集成。',
        //   url:require('@/assets/images/partners/6.png'),
        //   sites:'http://www.chenlux.com'
        // }, 
        {
          name:'新加坡',
          title:'INROVO PTE. LTD',
          value:'Inrovo成立于2017年，提供针对制造、物流、精密工程和食品行业的定制软件和硬件解决方案。公司专注于机器人技术、人工智能（AI）和物联网（IoT）。',
          url:require('@/assets/images/partners/12.png'),
          sites:'https://inrovo.com'
        }, 
        {
          name:'韩国',
          title:'ROAS INC.',
          value:'ROAS Inc. 专注于全面的机器人解决方案，包括工业机器人、基于ROS的机器人和服务机器人解决方案。公司在ROS集成和工厂及仓库自动化设计方面拥有丰富的经验。',
          url:require('@/assets/images/partners/18.png'),
          sites:'https://roas.co.kr'
        }, 
        {
          name:'日本',
          title:'RYOSAN CO. LTD',
          value:'Ryosan通过多年的技术专长和系统技术支持产品开发，积极推动各个行业的创新和进步。',
          url:require('@/assets/images/partners/19.png'),
          sites:'https://ryosan.co.jp'
        }, 
      ],
      contentList:[
        {
          name:'匈牙利',
          title:'AMTEST GROUP',
          value:'Amtest Group是中东欧增长最快的分销商，拥有员工和办事处，覆盖捷克共和国、匈牙利、波兰、罗马尼亚、斯洛伐克、保加利亚、塞尔维亚和斯洛文尼亚等本土市场。',
          url:require('@/assets/images/partners/Design ohne Titel (3).jpg'),
          sites:'https://amtest-group.com'
        }, 
        {
          name:'奥地利',
          title:'ASP AUTOMATIONSTECHNIK',
          value:'在装配技术组件的贸易和生产领域的合作伙伴。',
          url:require('@/assets/images/partners/364184210_598450809104323_6015410371130506518_n.jpg'),
          sites:'https://asp-gmbh.at'
        }, 
        {
          name:'西班牙',
          title:'CAMP TECNOLÓGICO',
          value:'Camp Tecnológico是一家专注于机器人技术、培训、销售和支持的公司。我们为大学、技术中心和企业提供协作机器人和服务机器人销售或租赁解决方案。',
          url:require('@/assets/images/partners/3.png'),
          sites:'https://camptecnologico.com'
        }, 
        {
          name:'比利时',
          title:'CATALYX',
          value:'Catalyx拥有超过35年的经验，为生命科学、消费品和物流领域的制造商提供定制化的机器视觉和自动化解决方案，支持北美和欧洲的客户。',
          url:require('@/assets/images/partners/4.png'),
          sites:'https://catalyx.ai'
        }, 
        {
          name:'斯洛伐克',
          title:'CEIT',
          value:'CEIT为工业企业带来提升生产力和效率的创新，重点是物流自动化、过程优化以及为智能工厂提供解决方案，推动向工业4.0转型。',
          url:require('@/assets/images/partners/5.png'),
          sites:'https://ceitgroup.eu'
        }, 
        {
          name:'波兰',
          title:'EDU4INDUSTRY',
          value:'Edu4Industry为大学和工程学院提供机器人和自动化工具，促进工程师培训，并支持应对工业4.0挑战的研究。',
          url:require('@/assets/images/partners/9.png'),
          sites:'https://edu4industry.com/en'
        }, 
        {
          name:'法国 / 德国',
          title:'GÉNÉRATION ROBOTS',
          value:'Generation Robots是可编程机器人在教育、研究和专业领域分销的领导者。它还集成了服务机器人，专注于自主和移动机器人解决方案。',
          url:require('@/assets/images/partners/10.png'),
          sites:'https://generationrobots.com'
        }, 
        // {
        //   name:'波兰',
        //   title:'HUSARION',
        //   value:'Husarion是一家领先的机器人公司，专注于自主移动机器人和UGV平台。通过基于ROS 2的平台，如ROSbot系列，Husarion支持全球范围内的研究、教育和工业中的机器人开发。',
        //   url:require('@/assets/images/partners/kovacs-engineering-logo.0df0119 (1).png'),
        //   sites:'https://husarion.com'
        // }, 
        {
          name:'匈牙利',
          title:'KOVACS ENGINEERING HUNGARY',
          value:'Kovacs Engineering自1997年起成为各行业领域的可靠合作伙伴，提供卓越的产品、解决方案和服务。',
          url:require('@/assets/images/partners/kovacs-engineering-logo.0df0119 (1).png'),
          sites:'https://kovacstrade.com'
        }, 
        {
          name:'罗马尼亚',
          title:'KOVACS TRADE COMPANY',
          value:'Kovacs Engineering成立的目的是为工业提供合适的解决方案，包括设备、服务、备件和消耗材料，以降低维护和总成本。',
          url:require('@/assets/images/partners/13.png'),
          sites:'https://kovacstrade.com'
        }, 
        {
          name:'丹麦',
          title:'PKJ ROBOTICS',
          value:'PKJ Robotics是一家机器人集成商，致力于开发自动化解决方案和定制化机器。公司拥有11,000平方米的生产面积和100名专业人员，提供全面的解决方案。',
          url:require('@/assets/images/partners/17.png'),
          sites:'https://pkj-robotics.dk'
        }, 
        {
          name:'德国',
          title:'VISION LASERTECHNIK GMBH',
          value:'Vision是一家机械工程公司，专注于激光技术、定制设备制造和工厂规划。凭借超过30年的经验，Vision将新的理念和技术引入工业领域。',
          url:require('@/assets/images/partners/20.png'),
          sites:'https://vision-lasertechnik.de'
        }, 
        {
          name:'荷兰',
          title:'WIREDWORKERS',
          value:'WiredWorkers是一家创新型初创公司，专注于机器人应用。我们提供先进的轻量级机器人，这些机器人具有高度灵活性，可以执行多种任务。',
          url:require('@/assets/images/partners/21.png'),
          sites:'https://wiredworkers.io'
        }, 
      ]
    }
  }, 
}
</script>

<style scoped>

.action-width{
  width: calc(33% - 40px);
}

/* 导航栏容器的样式 */
nav {
  color: #1B2F36;
  /* 背景色 */
}


/* 栅格布局，将 <ul> 设置为水平排列 */
ul.navbar {
  list-style-type: none;
  display: flex;
  padding: 10px;
}

/* 每个 <li> 的样式 */
ul.navbar li {
  position: relative;
  /* 相对定位，用于子菜单的绝对定位 */
  /* margin: 0 20px;   */
}

/* 链接的样式 */
ul.navbar li a {
  text-decoration: none;
  /* 去掉下划线 */
  font-size: 14px;
  padding: 10px 15px;
  /* 内边距 */
  display: block;
}

/* 子菜单（下拉菜单）样式 */
ul.dropdown-menu {
  /* border: 1px solid #1b2f364f; */
  border: 1px solid #e5e7eb;
  box-sizing: border-box;
  list-style-type: none;
  position: absolute;
  /* 绝对定位 */
  top: 100%;
  /* 放置在父菜单项的下方 */
  left: 0;
  background-color: white;
  /* 背景色 */
  display: none;
  /* 初始状态下隐藏 */
  width: 150px;
  /* 设置子菜单宽度 */
  border-radius: 5px;
  /* 圆角 */
  padding: 5px;
  /* box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);  */
}
 
/* 鼠标悬停时显示子菜单 */
ul.navbar li:hover>.dropdown-menu {
  display: block;
  /* 显示子菜单 */


}
/* 默认情况下，一行展示 4 个项目 */
.stress-content {
  display: flex;
  flex-wrap: wrap;
  gap: 20px; /* 项目之间的间隔 */
}
.company-content{ 
  display: flex;
  flex-wrap: wrap; 
  gap: 20px;  
}
.stress-content > div {
  width: calc(25% - 20px); /* 4 个项目 */
}
.company-content > div {
  width: calc(16.5% - 40px); /* 4 个项目 */
}
.display-width{
  width: calc(50% - 40px);
}
.ending-width{
  width: 35%;
}
.logo-alt {
  display: none; /* 默认隐藏 logo.svg */
}


@media (max-width: 1029px) {
  .action-width{
    width: calc(50% - 40px);
  } 
}


/* 屏幕宽度小于 1200px 时，一行展示 3 个 */
@media (max-width: 1199px) {
  .stress-content > div {
    width: calc(33.33% - 20px); /* 3 个项目 */
  }
  .company-content > div {
    width: calc(25% - 40px); /* 3 个项目 */
  } 
  .logo-main {
    display: none; /* 隐藏 logo-and-claim.svg */
  }

  .logo-alt {
    display: block; /* 显示 logo.svg */
  }
}

/* 屏幕宽度小于 900px 时，一行展示 2 个 */
@media (max-width: 899px) {
  .stress-content > div {
    width: calc(50% - 20px); /* 2 个项目 */
  } 
  .company-content > div {
    width: calc(33% - 40px); /* 3 个项目 */
  } 
  .display-width{
    width: 100%
  }
  .ending-width{
    width: 100%;
    margin-top: 40px;
  }
}

/* 屏幕宽度小于 600px 时，一行展示 1 个 */
@media (max-width: 599px) {
  .stress-content > div {
    width: 100%; /* 1 个项目 */
  } 
  .company-content > div {
    width: calc(50% - 40px); /* 3 个项目 */
  } 
  
  .action-width{
    width: calc(100% - 40px);
  }
}

</style>
<style scoped> 
/* h2 {
  font-size: 14px;
  margin-top: 10px;
  color: #333;
} */
</style>
